"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumLocationType = void 0;
exports.EnumLocationType = {
    CurrentLocation: 'CurrentLocation',
    Zip: 'Zip',
    Na: 'NA',
};
//# sourceMappingURL=enum-location-type.js.map